// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SalesInformation_checkbox__2flug","isEdit":"SalesInformation_isEdit__1zu8e"};